import { render, staticRenderFns } from "./RipaCheckGroup.vue?vue&type=template&id=36f2add9"
import script from "./RipaCheckGroup.vue?vue&type=script&lang=js"
export * from "./RipaCheckGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports